/**
 * @file 智能识别订单信息
 */

import merge from './merge';

// 为了提高匹配精度，首位不包含字母
const REGEX_LPN =
  /[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]([A-HJ-NP-Z0-9])[0-9]{4})|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳领]{1}))/;

/**
 * 联系人正则
 * contactByTitle 限制长度2-30, 因为联系人可能是公司
 * contactFlowedPhone 可以识别 `周杰伦19966669999` 中的`周杰伦`
 */
const REGEX_CONTACT =
  /((?:来电人姓名|联系人|被保险人名称|被保险人|报案人)[:：,，\s是]{0,4}(?<contactByTitle>[\u4e00-\u9fa5]{2,30}))|(?<contactFlowedPhone>(?:王|李|张|刘|陈|杨|黄|赵|吴|周|徐|孙|马|朱|胡|郭|何|高|林|罗|郑|梁|谢|宋|唐|许|韩|冯|邓|曹|彭|曾|肖|田|董|袁|潘|于|蒋|蔡|余|杜|叶|程|苏|魏|吕|丁|任|沈|姚|卢|姜|崔|钟|谭|陆|汪|范|金|石|廖|贾|夏|韦|傅|方|白|邹|孟|熊|秦|邱|江|尹|薛|闫|段|雷|侯|龙|史|黎|贺|顾|毛|郝|龚|邵|万|钱|覃|武|戴|孔|汤|庞|樊|兰|殷|施|陶|洪|翟|安|颜|倪|严|牛|温|芦|季|俞|章|鲁|葛|伍|申|尤|毕|聂|柴|焦|向|柳|邢|岳|齐|沿|梅|莫|庄|辛|管|祝|左|涂|谷|祁|时|舒|耿|牟|卜|路|詹|关|苗|凌|费|纪|靳|盛|童|欧|甄|项|曲|成|游|阳|裴|席|卫|查|屈|鲍|位|覃|霍|翁|隋|植|甘|景|薄|单|包|司|柏|宁|柯|阮|桂|闵|欧阳|解|强|丛|华|车|冉|房|边|辜|吉|饶|刁|瞿|戚|丘|古|米|池|滕|晋|苑|邬|臧|畅|宫|来|嵺|苟|全|褚|廉|简|娄|盖|符|奚|木|穆|党|燕|郎|邸|冀|谈|姬|屠|连|郜|晏|栾|郁|商|蒙|计|喻|揭|窦|迟|宇|敖|糜|鄢|冷|卓|花|艾|蓝|都|巩|稽|井|练|仲|乐|虞|卞|封|竺|冼|原|官|衣|楚|佟|栗|匡|宗|应|台|巫|鞠|僧|桑|荆|谌|银|扬|明|沙|薄|伏|岑|习|胥|保|和|蔺|水|云|昌|凤|酆|常|皮|康|元|平|萧|湛|禹|无|贝|茅|麻|危|骆|支|咎|经|裘|缪|干|宣|贲|杭|诸|钮|嵇|滑|荣|荀|羊|於|惠|家|芮|羿|储|汲|邴|松|富|乌|巴|弓|牧|隗|山|宓|蓬|郗|班|仰|秋|伊|仇|暴|钭|厉|戎|祖|束|幸|韶|蓟|印|宿|怀|蒲|鄂|索|咸|籍|赖|乔|阴|能|苍|双|闻|莘|贡|逢|扶|堵|宰|郦|雍|却|璩|濮|寿|通|扈|郏|浦|尚|农|别|阎|充|慕|茹|宦|鱼|容|易|慎|戈|庚|终|暨|居|衡|步|满|弘|国|文|寇|广|禄|阙|东|殴|殳|沃|利|蔚|越|夔|隆|师|厍|晃|勾|融|訾|阚|那|空|毋|乜|养|须|丰|巢|蒯|相|后|红|权逯|盖益|桓|公|万俟|司马|上官|夏侯|诸葛|闻人|东方|赫连|皇甫|尉迟|公羊|澹台|公冶|宗政|濮阳|淳于|单于|太叔|申屠|公孙|仲孙|轩辕|令狐|钟离|宇文|长孙|慕容|鲜于|闾丘|司徒|司空|亓官|司寇|仉|督|子车|颛孙|端木|巫马|公西|漆雕|乐正|壤驷|公良|拓跋|夹谷|宰父|谷粱|法|汝|钦|段干|百里|东郭|南门|呼延|归海|羊舌|微生|帅|缑|亢|况|郈|琴|梁丘|左丘|东门|西门|佘|佴|伯|赏|南宫|墨|哈|谯|笪|年|爱|仝|代|粟){1}[\u4e00-\u9fa5]{1,2})\s{0,2}\d{11}\b/;

const REGEXS_GROUP_1 = {
  // 车牌正则
  licensePlateNo: REGEX_LPN,
  // 识别手机号或者座机
  phone: /\b(?:(?:[1][3-9]\d{9})|(?:0\d{2,3}-?\d{7,8}))\b/,
  // 报案号
  caseNo: /\b[A-Z][A-Z\d]{17,}\b/
};

// [:：,，\s是]{0,4}
const REGEXS_GROUP_2 = {
  // 报案号
  caseNo:
    /(?:报案|外部单|服务|流水|救援)号[:：,，\s是]{0,4}(?<caseNo>[a-zA-Z\d]{14,})/,
  // ---- 下方的为R2独有的
  // 联系人
  contact: REGEX_CONTACT,

  // 联系人 -- 李先生 李女士
  contactTitle: /(?<contactTitle>[\u4e00-\u9fa5]{1,2}(?:先生|女士))/,
  // 服务起点
  address:
    /(?:(?:起|地)点|地址)[:：,，\s是]{0,4}(?<address>[\u4e00-\u9fa5\w\(\)\/]+\s?[\u4e00-\u9fa5\w\(\)\/]*)/
};

async function matchWithGroup(str = '', regex) {
  const match = str.match(regex);
  return match && match.groups ? match.groups : null;
}

/**
 * 整理识别结果
 */
function keyAdapter(result) {
  const res = {
    carNo: result.licensePlateNo, // 车牌
    caseNo: result.caseNo, // 报案号
    contactPhone: result.phone, // 联系电话
    contactAddress: result.address, // 服务地址
    contactName: result.contactTitle || result.contactByTitle || result.contactFlowedPhone || result.title // 联系人
  };

  console.log(res);

  return res;
}

/**
 * 根据正则直接识别，用于识别规则明显的信息
 */
async function parseByOnlyRegex(str) {
  if (typeof str !== 'string' || str.length < 1) return;
  const result = {};
  for (const [key, regex] of Object.entries(REGEXS_GROUP_1)) {
    const match = str.match(regex);
    if (match) {
      result[key] = match[0];
    }
  }
  return result;
}

/**
 * 根据title识别信息
 * @returns
 */
async function parseWithTitle(str) {
  const result = {};
  const matchs = Object.values(REGEXS_GROUP_2).map((regex) =>
    matchWithGroup(str, regex)
  );

  for (const match of matchs) {
    const res = await match;
    if (res) Object.assign(result, res);
  }
  return result;
}

/**
 * 识别字符串中包含的订单信息
 * @param {String} str
 * @returns {Object} - 识别出的结果
 */
export async function parseOrderInfo(str) {
  const [res1, res2] = await Promise.all([
    parseByOnlyRegex(str),
    parseWithTitle(str)
  ]);

  // 合并结果, 部分字段由文字转为code
  const result = merge({}, res1, res2);

  // 调整字段名
  return keyAdapter(result);
}
